import { useYoloModal } from 'lib/yoloModals/useYoloModal'
import { useCallback } from 'react'
import { Close, SignInModalCSS } from './SignInModalCSS.styled'
import { Tabs } from './Tabs'

const SIGN_UP_MODAL_OBJ = {
  // this component will receive `closeModal` prop to close programmatically the modal
  show: true,
  id: 'signUp',
}

export const SignInModal = ({ closeModal }) => {
  const { updateModal } = useYoloModal()

  const openSignUpModal = useCallback(
    () => {
      updateModal(SIGN_UP_MODAL_OBJ)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  return (
    <SignInModalCSS>
      <div className='popUpContainer user-signin variable-width'>
        <article>
          <Close name='close2' masking onClick={closeModal} />
          <Tabs closeModal={closeModal} openSignUpModal={openSignUpModal} />
          <div className='panels'>
            <div className='signin_marketing_panel'>
              <div className='client_logo wallstreetbets'>
                {/* <img src='resources/images/wsb/wsb_logo_neon.png' /> */}
              </div>

              <div className='user_alternate_access'>
                <span>Don't have an account?</span>
                <button onClick={openSignUpModal}>Register</button>
              </div>

              <div className='access_statement'>
                By accessing this site, I attest that I am at least 18 years old and have read the{' '}
                <a href='https://docs.yolorekt.finance/legal/terms-of-service' target='blank'>
                  Terms &amp; Conditions
                </a>
                .
              </div>
            </div>
          </div>
        </article>
      </div>
    </SignInModalCSS>
  )
}
